import script from "./Point.vue?vue&type=script&setup=true&lang=js"
export * from "./Point.vue?vue&type=script&setup=true&lang=js"

import "./Point.vue?vue&type=style&index=0&id=8c1afdfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c1afdfa"]])

export default __exports__